import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单返厂',
  path: 'SingleDepot'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'SingleDepot',
    component: () => import(/* webpackChunkName: "SignTheReceipt" */ '@/views/receiptManagement/singleDepot/index.vue'),
    meta: {
      title: '回单返厂'
    }
  },
  // 回单返厂打印
  {
    path: getPath('hdfc_printView', baseUrl),
    name: 'Hdfc_PrintView',
    component: () => import(/* webpackChunkName: "fdpz_printView" */ '@/views/receiptManagement/hdfc_printView/index.vue'),
    meta: {
      title: '打印'
    }
  }
]
